import { render } from "./PlatformCreate.vue?vue&type=template&id=8a50d06a&ts=true"
import script from "./PlatformCreate.vue?vue&type=script&lang=ts"
export * from "./PlatformCreate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__